// extracted by mini-css-extract-plugin
export default {"arrowWrapper":"expandableArrow_arrowWrapper__sF46M","arrow":"expandableArrow_arrow__VkEAL","rotated":"expandableArrow_rotated__KOq0P"};